/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../styles';
import { Track, TrackCreate } from 'src/@types/tracks';
import TrackNewEditForm from 'src/sections/@dashboard/track/TrackNewEditForm';

export const TrackModal = ({
  open,
  handleClose,
  isEdit,
  currentTrack,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentTrack: Track | undefined;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <TrackNewEditForm handleClose={handleClose} isEdit={isEdit} currentTrack={currentTrack} />
      </StyledModalBox>
    </Modal>
  );
};
